<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.multiDocView}}</h3>
</div>
<div class="modal-body container diff-modal-window">
	<ul ngbNav #nav="ngbNav" class="nav nav-tabs nav-justified">
	  <li ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink>
	      <i class="fa fa-eye"></i> {{ LOCALIZATION.view }}
	    </a>
	    <ng-template ngbNavContent>
	    	<!-- Doc view -->
			<div class="row">
				<!-- Left -->
				<div class="col-xs-6">
					<select class="form-control" [(ngModel)]="tracker.left" (change)="initDiffSide(true)">
					  <option *ngFor="let product of products; let i = index" [ngValue]="i">{{ product.title }}</option>
					</select>
					<!-- Deprecated? -->
<!-- 					<div *ngIf="leftImage['pages'] && leftImage['pages'].length > 0"><span>{{LOCALIZATION.page}}</span> {{ leftImage['page']?.['pageNum'] || '' }}  -->
<!-- 						<select class="form-control" [(ngModel)]="tracker.leftPageIndex" (change)="changePage(true)"> -->
<!-- 							<option *ngFor="let page of leftImage['pages']; let i = index" [ngValue]="i">{{ page?.pageNum || '' }}</option> -->
<!-- 						</select> -->
<!-- 					</div> -->
					<br>
					<div *ngIf="userPermissions['ROLE_PRODUCT_DELETE']">
						<button class="btn btn-danger" (click)="deleteDocument(true)">{{LOCALIZATION.deleteItem}}</button>
					</div>
					<br>
 					<div class="diff-viewer-container"> 
				 		<!-- SEPARATE COMPONENT METADATA-ONLY View -->
						<div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'metadata'" class="well metadata-view-panel" style="position:relative;overflow:auto;max-height:100%">      
				        	<doc-metadata-view [product]="leftImage['product']"></doc-metadata-view>
				        </div>       
				        
				        <!-- SEPARATE COMPONENT Video View -->
				        <div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'video'" class="text-center">
							<doc-video-view 
								[product]="leftImage['product']" 
								[viewerURL]="leftImage['viewerURL']" 
								[viewerOverviewURL]="leftImage['viewerOverviewURL']"
								[downloadDocumentLink]="null"
								[downloadDocumentPageLink]="null"
								[pages]="leftImage['pages']">
							</doc-video-view>
				        </div>
				
				 		<!-- SEPARATE COMPONENT Audio View -->
						<div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'audio'" class="text-center">      
				        	<doc-audio-view [product]="leftImage['product']" [viewerURL]="leftImage['viewerURL']" [viewerOverviewURL]="leftImage['viewerOverviewURL']"></doc-audio-view>
				        </div> 
				        
						<!-- SEPARATE COMPONENT PDF View -->
						<div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'pdf'" style='width:100%; height:100%;'>       
				        	<doc-pdf-view 
				        		[product]="leftImage['product']" 
				        		[documentData]="leftImage['documentData']" 
				        		[viewerURL]="leftImage['viewerURL']" 
				        		[package]="leftImage['package']" 
				        		[page]="leftImage['page']"
				        		[selectedPage]="0">
				        	</doc-pdf-view>
				        </div>
				
						<!-- SEPARATE COMPONENT TEXT View -->
						<div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'text'" style='width:100%; height:100%;'>        
						    <doc-text-view [product]="leftImage['product']" [documentData]="leftImage['documentData']" [viewerURL]="leftImage['viewerURL']"></doc-text-view>
				        </div>
				        
				        <!-- SEPARATE COMPONENT IMAGE View -->
				        <div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'image' || leftImage?.['pageDescription']?.['currView'] === 'image-default'">
				        	<doc-image-view 
					        	[product]="leftImage['product']" 
					        	[documentData]="leftImage['documentData']" 
					        	[viewerURL]="leftImage['viewerURL']"
					        	[chippingEnabled]="false">
				        	</doc-image-view>
				        </div>        
								
						<!-- Opens an external third-party viewer (https://arcgis.com/home/webmap/viewer.html). This appears to be a fringe case.  -->
				        <div *ngIf="leftImage?.['pageDescription']?.['currView'] === 'external_arcgis' && mapViewEnabled" 
				        	 style='width:100%;height:100%;background-color:#f8f8f8;position:relative;'>
				            <iframe [hidden]="leftImage['viewerURL'] == null" id='extArcGisViewerL' [src]="leftImage['viewerURL']" width="100%" height="100%" (error)="arcgis_onerror()"></iframe>
				        </div>				        
				        
				        <!-- SEPARATE COMPONENT Geo View -->
				        <div *ngIf="(leftImage?.['pageDescription']?.['currView'] === 'arcgis' || leftImage?.['pageDescription']?.['currView'] === 'map') && mapViewEnabled" 
				        	 style='width:100%; height:100%; background-color:#f8f8f8; position:relative;'>
				        	<doc-geo-view 
					        	[product]="leftImage['product']" 
					        	[documentData]="leftImage['documentData']" 
					        	[viewerURL]="leftImage['viewerURL']"
					        	[viewType]="leftImage['pageDescription']['currView']">
					        </doc-geo-view>
				        </div>
					</div>
				</div>
				<!-- Right -->
				<div class="col-xs-6">
					<select class="form-control" [(ngModel)]="tracker.right" (change)="initDiffSide(false)">
					  <option *ngFor="let product of products; let i = index" [ngValue]="i">{{ product.title }}</option>
					</select>
					<!-- Deprecated? -->
<!-- 					<div *ngIf="rightImage['pages'] && rightImage['pages'].length > 0"><span>{{LOCALIZATION.page}}</span> {{ rightImage['page']?.['pageNum'] || '' }}  -->
<!-- 						<select class="form-control" [(ngModel)]="tracker.rightPageIndex" (change)="changePage(false)"> -->
<!-- 							<option *ngFor="let page of rightImage['pages']; let i = index" [ngValue]="i">{{ page?.pageNum || '' }}</option> -->
<!-- 						</select> -->
<!-- 					</div> -->
					<br>
					<div *ngIf="userPermissions['ROLE_PRODUCT_DELETE']">
						<button class="btn btn-danger" (click)="deleteDocument(false)">{{LOCALIZATION.deleteItem}}</button>
					</div>
					<br>
 					<div class="diff-viewer-container"> 
				 		<!-- SEPARATE COMPONENT METADATA-ONLY View -->
						<div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'metadata'" class="well metadata-view-panel" style="position:relative;overflow:auto;max-height:100%">      
				        	<doc-metadata-view [product]="rightImage['product']"></doc-metadata-view>
				        </div>       
				        
				        <!-- SEPARATE COMPONENT Video View -->
				        <div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'video'" class="text-center">
							<doc-video-view 
								[product]="rightImage['product']" 
								[viewerURL]="rightImage['viewerURL']" 
								[viewerOverviewURL]="rightImage['viewerOverviewURL']"
								[downloadDocumentLink]="null"
								[downloadDocumentPageLink]="null"
								[pages]="rightImage['pages']">
							</doc-video-view>
				        </div>
				
				 		<!-- SEPARATE COMPONENT Audio View -->
						<div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'audio'" class="text-center">      
				        	<doc-audio-view [product]="rightImage['product']" [viewerURL]="rightImage['viewerURL']" [viewerOverviewURL]="rightImage['viewerOverviewURL']"></doc-audio-view>
				        </div> 
				        
						<!-- SEPARATE COMPONENT PDF View -->
						<div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'pdf'" style='width:100%; height:100%;'>       
				        	<doc-pdf-view 
				        		[product]="rightImage['product']" 
				        		[documentData]="rightImage['documentData']" 
				        		[viewerURL]="rightImage['viewerURL']" 
				        		[package]="rightImage['package']" 
				        		[page]="rightImage['page']"
				        		[selectedPage]="0">
				        	</doc-pdf-view>
				        </div>
				
						<!-- SEPARATE COMPONENT TEXT View -->
						<div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'text'" style='width:100%; height:100%;'>        
						    <doc-text-view [product]="rightImage['product']" [documentData]="rightImage['documentData']" [viewerURL]="rightImage['viewerURL']"></doc-text-view>
				        </div>
				        
				        <!-- SEPARATE COMPONENT IMAGE View -->
				        <div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'image' || rightImage?.['pageDescription']?.['currView'] === 'image-default'">
				        	<doc-image-view 
					        	[product]="rightImage['product']" 
					        	[documentData]="rightImage['documentData']" 
					        	[viewerURL]="rightImage['viewerURL']"
					        	[chippingEnabled]="false"
					        	[projectionEnabled]="false">
				        	</doc-image-view>
				        </div>        
								
						<!-- Opens an external third-party viewer (https://arcgis.com/home/webmap/viewer.html). This appears to be a fringe case.  -->
				        <div *ngIf="rightImage?.['pageDescription']?.['currView'] === 'external_arcgis' && mapViewEnabled" 
				        	 style='width:100%;height:100%;background-color:#f8f8f8;position:relative;'>
				            <iframe [hidden]="rightImage['viewerURL'] == null" id='extArcGisViewerR' [src]="rightImage['viewerURL']" width="100%" height="100%" (error)="arcgis_onerror()"></iframe>
				        </div>					        
				        
				    	<!-- SEPARATE COMPONENT Geo View -->
				        <div *ngIf="(rightImage?.['pageDescription']?.['currView'] === 'arcgis' || rightImage?.['pageDescription']?.['currView'] === 'map') && mapViewEnabled" 
				        	 style='width:100%; height:100%; background-color:#f8f8f8; position:relative;'>
				        	<doc-geo-view 
					        	[product]="rightImage['product']" 
					        	[documentData]="rightImage['documentData']" 
					        	[viewerURL]="rightImage['viewerURL']"
					        	[viewType]="rightImage['pageDescription']['currView']">
					        </doc-geo-view>
				        </div>
					</div>
				</div>				
			</div>	    	
	    </ng-template>
	  </li>
	  <li ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink>
	      <i class="fa fa-th-list"></i> {{ LOCALIZATION.metadata }}
	    </a>
	    <ng-template ngbNavContent>
	    	<!-- Metadata -->
			<div class="diff-metadata-container row">
				<div id="collapseOne" aria-labelledby="headingOne">
					<div class="panel-body">
						<table class="table table-striped table-bordered">
							<tr *ngFor='let data of allProductInfo'>
								<th>{{data.field}}</th>
								<td>{{data.left}}</td>
								<td>{{data.right}}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>	    	
	    </ng-template>	    
	  </li>	  	  
	</ul>
	<div [ngbNavOutlet]="nav"></div>

</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
